import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import FormLabel from '@material-ui/core/FormLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '@material-ui/core/Button';
import StationSelect from './StationStatisticsSelect';

import * as statisticsReducers from '../reducer';
import * as statisticsActionMgr from '../action-mgr';
import * as strings from '../../helpers/strings';

const styles = {
  formControlWrapper: { marginBottom: 15 },
  formControlWrapperSelectMenu: {
    '& > div > div': {
      boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)' 
    }
  },
  formControlCheckboxWrapper: { 
    width: '100%', 
    marginBottom: 15, 
    padding: '15px', 
    border: '1px solid #0000003d', 
    borderRadius: '5px', 
    boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)'
  },
  CheckboxFormLabel: { textAlign: 'left', padding: '0px 2px', fontSize: '13px', width: '55px' },
};

const sortSetting = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' })
class StationStatisticsForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      yearList: [],
      downloadButtonDisabled: true,
      selectAllFacilities: true,
    };
  }

  componentDidMount() {
    const { selectedStationName, callStatisticsTotalize, callEnergyMeterList } = this.props;
    
    if (selectedStationName) {
      callStatisticsTotalize(selectedStationName);
      callEnergyMeterList(selectedStationName);
    }
  }

  componentDidUpdate(prevProps) {
    const { selectedStationName, callStatisticsTotalize, callEnergyMeterList } = this.props;

    if (prevProps.selectedStationName !== selectedStationName) {
      callStatisticsTotalize(selectedStationName);
      callEnergyMeterList(selectedStationName);
    }

    if (prevProps.statisticsFilter !== this.props.statisticsFilter) {
      const { callOtherData, statisticsFilter } = this.props;
      let params = {
        "stationName": selectedStationName,
        "facility": statisticsFilter.facilitys.toString(),
      };
      if (statisticsFilter.time !== "all") { params.time = statisticsFilter.time }

      callOtherData(params);
    }

    if ((this.props.statisticsFilter.time === "all") && (prevProps.otherData !== this.props.otherData)) {
      this.setState({
        yearList: (_.uniqBy(this.props.otherData, od => od.time)).map(o => o.time)
      });
    }

    if (
      prevProps.selectedStationName !== this.props.selectedStationName ||
      prevProps.statisticsFilter !== this.props.statisticsFilter ||
      prevProps.otherData !== this.props.otherData
    ) {
      const downloadButtonDisabled =
        !this.props.otherData || this.props.otherData.length === 0;
      this.setState({ downloadButtonDisabled });
    }
  }

  handleTypeChange = event => {
    const { selectStatisticsType, energyMeterList, selectStatisticsFacilitys } = this.props;
    selectStatisticsType(event.target.value);
    let findFacilitys = _.filter(energyMeterList, e => e.type === event.target.value);
    selectStatisticsFacilitys(findFacilitys[0].facilitys.split(","));

    this.setState({ selectAllFacilities: true });
  }

  handleYearChange = event => {
    const { setSelectYear } = this.props;
    setSelectYear(event.target.value);
  }

  handleSelectField = event => {
    const { energyMeterList, statisticsFilter, selectStatisticsFacilitys } = this.props;
    let cloneFacilitys = [...statisticsFilter.facilitys];
    let findIndex = cloneFacilitys.findIndex(f => f === event.target.value);

    if (findIndex >= 0) {
      cloneFacilitys.splice(findIndex, 1);
    } else {
      cloneFacilitys.push(event.target.value);
    }

    selectStatisticsFacilitys(cloneFacilitys);
    const allFacilities = energyMeterList
      .filter(f => f.type === statisticsFilter.type)
      .flatMap(f => f.facilitys.split(','));
    const allFacilitiesSelected = allFacilities.every(facility => cloneFacilitys.includes(facility));
    this.setState({ selectAllFacilities: allFacilitiesSelected });
  }

  handleSelectAllFacilities = () => {
    const { energyMeterList, statisticsFilter, selectStatisticsFacilitys } = this.props;
    const { selectAllFacilities } = this.state;
  
    const allFacilities = energyMeterList
      .filter(f => f.type === statisticsFilter.type)
      .flatMap(f => f.facilitys.split(','));
  
    if (selectAllFacilities) {
      selectStatisticsFacilitys([]);
    } else {
      selectStatisticsFacilitys(allFacilities);
    }
  
    this.setState({ selectAllFacilities: !selectAllFacilities });
  };

  handleDownloadClick = () => {
    const { statisticsTotalize, otherData, selectedStationName, statisticsFilter } = this.props;
  
    const modifiedOtherData = otherData.map(data => ({
      ...data,
      energyYields: data.energyYields === 0 ? 'NA' : data.energyYields,
      performanceRatio: data.performanceRatio === 0 ? 'NA' : data.performanceRatio,
      insolation: data.insolation === 0 ? 'NA' : data.insolation,
    }));
  
    if (statisticsTotalize && modifiedOtherData && modifiedOtherData.length > 0) {
      const facilities = [...new Set(modifiedOtherData.map(data => data.facility))]; 
      facilities.sort();
  
      const facilityDataMap = {};
      facilities.forEach(facility => {
        facilityDataMap[facility] = {
          insolation: [],
          performanceRatio: [],
          energyYields: []
        };
      });
  
      modifiedOtherData.forEach(data => {
        facilityDataMap[data.facility].insolation.push(data.insolation);
        facilityDataMap[data.facility].performanceRatio.push(data.performanceRatio);
        facilityDataMap[data.facility].energyYields.push(data.energyYields);
      });
  
      const dynamicHeaders = [
        'System Capacity (kWp)', 'Annual Energy Yields (MWh)', 'Annual Performance Ratio (%)',
        'Average Annual Degradation (%)', 'Annual Insolation (kWh/m²/year)'
      ];
  
      const statisticTotalizeData = [
        [
          parseInt(statisticsTotalize.systemCapacity).toFixed(1),
          (parseFloat(statisticsTotalize.annualEnergyYields) / 1000).toFixed(1),
          parseInt(statisticsTotalize.annualPerformanceRatio).toFixed(1),
          parseInt(statisticsTotalize.averageAnnualDegration).toFixed(1),
          parseInt(statisticsTotalize.annualInsolation).toFixed(1)
        ]
      ];
  
      const facilityHeaders = ['Time'];
      facilities.forEach(facility => {
        facilityHeaders.push(`${facility} Insolation (${statisticsFilter.time === 'all' ? 'kWh/m²/year' : 'kWh/m²/month'})`);
        facilityHeaders.push(`${facility} PR (%)`);
        facilityHeaders.push(`${facility} Energy Yields (kWh)`);
      });
      facilityHeaders.push('Total Energy Consumption (kWh)');
  
      const facilityData = [];
      const timeData = [...new Set(otherData.map(data => data.time))];
      timeData.forEach((time, index) => {
        const rowData = [time];
        let totalEnergyConsumption = 0;
        facilities.forEach(facility => {
          const facilityData = facilityDataMap[facility];
          const facilityDataRow = facilityData.insolation.shift() || ''; 
          const energyYields = facilityData.energyYields.shift() || '';
          totalEnergyConsumption += !isNaN(parseFloat(energyYields)) ? parseFloat(energyYields) : 0;
          rowData.push(facilityDataRow);
          rowData.push(facilityData.performanceRatio.shift() || '');
          rowData.push(energyYields);
        });
        rowData.push(totalEnergyConsumption === 0 ? 'NA' : totalEnergyConsumption); 
        facilityData.push(rowData);
      });
  
      const csvRows = [];
      csvRows.push(dynamicHeaders.join(','));
      statisticTotalizeData.forEach(data => csvRows.push(data.join(',')));
      csvRows.push('');
      csvRows.push(facilityHeaders.join(','));
      facilityData.forEach(data => csvRows.push(data.join(',')));
  
      const csvData = '\uFEFF' + csvRows.join('\n');
      const filename = `${selectedStationName}_Statistics.csv`;
  
      const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8' });
      const url = URL.createObjectURL(blob);
  
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.click();
  
      URL.revokeObjectURL(url);
    }
  };  

  render() {
    const { energyMeterList, statisticsFilter, classes } = this.props;
    const { selectAllFacilities } = this.state;
    const filterFacilitys = energyMeterList.filter(f => f.type === statisticsFilter.type);

    return (
      <div className={classes.form} >
        <Grid container alignItems="center">
           <Grid item xs={12}>
            <StationSelect />
          </Grid>
          <Grid item xs={12}>
            <FormControl className={classes.formControlWrapper} variant={strings.txtOutlined} fullWidth={true}>
              <InputLabel htmlFor="type">Year</InputLabel>
              <Select
                value={statisticsFilter.time}
                onChange={this.handleYearChange}
                input={
                  <OutlinedInput
                    labelWidth={60}
                    name="Type"
                    id="type"
                    key="typeSelect"
                    className={classes.formControlWrapperSelectMenu}
                  />
                }
              >
                <MenuItem key={`time_all`} value={'all'}>  All </MenuItem>
                {(this.state.yearList.length > 0) &&
                  this.state.yearList.map((y, index) =>
                    <MenuItem key={`time_${index}`} value={y}>  {y} </MenuItem>
                  )}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl className={classes.formControlWrapper} variant={strings.txtOutlined} fullWidth={true}>
              <InputLabel htmlFor="type">Type</InputLabel>
              <Select
                value={statisticsFilter.type}
                onChange={this.handleTypeChange}
                input={
                  <OutlinedInput
                    labelWidth={60}
                    name="Type"
                    id="type"
                    key="typeSelect"
                    className={classes.formControlWrapperSelectMenu}
                  />
                }
              >
                {energyMeterList.map((data, index) =>
                  <MenuItem key={`type_${index}`} value={data.type}>  {data.type} </MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl component="fieldset" className={classes.formControlCheckboxWrapper}>
              <FormLabel component="legend" className={classes.CheckboxFormLabel}>Facilities</FormLabel>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      value="selectAll"
                      color={strings.colorPrimary}
                      checked={selectAllFacilities}
                      onClick={this.handleSelectAllFacilities}
                    />
                  }
                  label="All"
                />
                {(filterFacilitys.length > 0) &&
                  filterFacilitys[0].facilitys.split(",").sort(sortSetting.compare).map(facility =>
                    <div key={facility}>
                      <FormControlLabel
                        key={facility}
                        checked={(statisticsFilter.facilitys.includes(facility) ? true : false)}
                        control={
                          <Checkbox
                            value={facility}
                            color={strings.colorPrimary}
                            key={`facility_${facility}`}
                            onClick={this.handleSelectField}
                          />
                        }
                        label={facility}
                      />
                    </div>
                  )}
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item xs={12} container justify="flex-start">
            <Button
              variant="contained"
              color={strings.colorPrimary}
              size="medium"
              style={{ opacity: this.state.downloadButtonDisabled ? 0.5 : 1 }}
              disabled={this.state.downloadButtonDisabled}
              onClick={this.handleDownloadClick}
            >
              Download
            </Button>
          </Grid>                    
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  selectedStationName: statisticsReducers.getSelectedStatisticsStationName(state),
  statisticsTotalize: statisticsReducers.getStatisticsTotalize(state),
  energyMeterList: statisticsReducers.getEnergyMeterList(state),
  statisticsFilter: statisticsReducers.getStatisticsFilter(state),
  otherData: statisticsReducers.getOtherData(state),
});

const mapActionsToProps = {
  callStatisticsTotalize: statisticsActionMgr.callStatisticsTotalize,
  callEnergyMeterList: statisticsActionMgr.callEnergyMeterList,
  selectStatisticsType: statisticsActionMgr.selectStatisticsType,
  selectStatisticsFacilitys: statisticsActionMgr.selectStatisticsFacilitys,
  callOtherData: statisticsActionMgr.callOtherData,
  setSelectYear: statisticsActionMgr.setSelectYear,
};

export default connect(mapStateToProps, mapActionsToProps)(
  withStyles(styles)(StationStatisticsForm)
);
